import React from 'react'
import './PlayerFooter.css'

export default class PlayerFooter extends React.PureComponent {

	render() {
		return (
			<div
				className="player__footer"
				/>)
	}
}



// WEBPACK FOOTER //
// ./src/components/player/controls/footer/PlayerFooter.jsx